export default "/react/logoKeysSo-068cdff5.png";